import { render } from "./list_two.vue?vue&type=template&id=1f6cd871&scoped=true"
import script from "./list_two.vue?vue&type=script&lang=js"
export * from "./list_two.vue?vue&type=script&lang=js"

import "./list_two.vue?vue&type=style&index=0&id=1f6cd871&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f6cd871"]])

export default __exports__